<template>
	<div>
		<el-dialog
			:visible.sync="showgroupwin"
			:title="groupkey == '' ? '新增门店' : '修改门店'"
			width="900px"
			:close-on-click-modal="false"
			lock-scroll
			:modal-append-to-body="false"
			:show-close="false"
		>
			<div class="group">
				<table class="htmltable">
					<tr>
						<td>
							<span>门店名称</span>
						</td>
						<td>
							<el-input size="mini" v-model="groupinfo.s_name" type="text" @input="changeinput"></el-input>
						</td>
						<td>
							<span>门店角色</span>
						</td>
						<td>
							<el-select size="mini" v-model="groupinfo.r_name" :style="{ width: `200px` }">
								<el-option v-for="p in r_namelist" :key="p.value" :label="p.label" :value="p.value"></el-option>
							</el-select>
						</td>
						<td>
							<span>财务方案</span>
						</td>
						<td>
							<el-select size="mini" v-model="groupinfo.c_id" :style="{ width: `200px` }">
								<el-option v-for="p in cwlist" :key="p.value" :label="p.label" :value="p.value"></el-option>
							</el-select>
						</td>
					</tr>
					<tr>
						<td>
							<span>门店描述</span>
						</td>
						<td colspan="5">
							<el-input size="mini" v-model="groupinfo.remark" type="textarea"  @input="changeinput"></el-input>
						</td>
					</tr>
					<tr>
						<td colspan="6">
							 <el-divider content-position="left">收货地址</el-divider>
						</td>
					</tr>
					<tr>
						<td>
							<span>收货姓名</span>
						</td>
						<td>
							<el-input size="mini" v-model="groupinfo.name" type="text" :style="{ width: `200px` }" @input="changeinput"></el-input>
						</td>
						<td>
							<span>收货电话</span>
						</td>
						<td>
							<el-input size="mini" v-model="groupinfo.phone" type="text" :style="{ width: `200px` }" @input="changeinput"></el-input>
						</td>
						<!-- <td>
							<span>收件国家</span>
						</td>
						<td>
							<el-select
								v-model="groupinfo.country"
								filterable
								remote
								reserve-keyword
								placeholder="可输入关键词搜索"
								:remote-method="val => addrinput(val)"
								:loading="loading"
								size="mini"
							>
								<el-option v-for="item in countrylist" :key="item.showname" :label="item.showname" :value="item.showname"></el-option>
							</el-select>
						</td> -->
					</tr>
					<tr>
						<td>
							<span>收货地址</span>
						</td>
						<td colspan="5">
							<el-input size="mini" v-model="groupinfo.addressall" type="textarea" @input="changeinput"></el-input>
						</td>
					</tr>
					<!-- <tr>
						<td>
							<span>收件省份/州</span>
						</td>
						<td>
							<el-input size="mini" v-model="groupinfo.province" type="text" :style="{ width: `200px` }" @input="changeinput"></el-input>
						</td>
						<td>
							<span>收件城市</span>
						</td>
						<td>
							<el-input size="mini" v-model="groupinfo.city" type="text" :style="{ width: `200px` }" @input="changeinput"></el-input>
						</td>
						<td>
							<span>收件区</span>
						</td>
						<td>
							<el-input size="mini" v-model="groupinfo.district" type="text" :style="{ width: `200px` }" @input="changeinput"></el-input>
						</td>
					</tr>
					<tr>
						<td>
							<span>详细地址</span>
						</td>
						<td colspan="3">
							<el-input size="mini" v-model="groupinfo.detailaddr" type="text" @input="changeinput"></el-input>
						</td>
						<td>
							<span>收件邮编</span>
						</td>
						<td colspan="3">
							<el-input size="mini" v-model="groupinfo.postcode" type="text" :style="{ width: `200px` }" @input="changeinput"></el-input>
						</td>
					</tr> -->
<!-- 					<tr>
						<td colspan="6">
							<el-divider content-position="left">个性化</el-divider>
						</td>
					</tr>
					<tr>
						<td>
							<span>专属标题</span>
						</td>
						<td colspan="5">
							<el-input v-model="groupinfo.webtitle" style="width:400px" placeholder="用于登录页展示的标题" size="mini"></el-input>
						</td>
					</tr>
					<tr>
						<td>
							<span>专属域名</span>
						</td>
						<td colspan="5" style="padding-right:0px">
							<table style="padding-right:0px;">
								<tr>
									<td colspan="2" style="color:#FF0000">请先将域名解析到此IP : {{ ip }},否则域名无法正常访问</td>
								</tr>
								<tr v-for="(item, index) in groupinfo.domain" style="height:40px">
									<td><el-input style="width:400px" size="mini" type="text" v-model="item.name" placeholder="以http://开头 或者直接写域名即可"></el-input></td>
									<td>
										<i class="el-icon-plus" @click="adddomain"></i>
										<i class="el-icon-minus" @click="removedomain(index)" v-if="index > 0" style="margin-left:10px"></i>
									</td>
								</tr>
							</table>
						</td>
					</tr>
					 -->
					<tr>
						<td colspan="6" style="text-align:center;">
							<el-button type="success" size="mini" @click="savegroup" :disabled="btndisabled">保存</el-button>
							<el-button size="mini" @click="showgroupwin = false">取消</el-button>
						</td>
					</tr>
				</table>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: {
		
	},
	data() {
		return {
			groupinfo: {
				s_name: '',
				isshop: 'true',
				r_name: '',
				c_id: '',
				country: '',
				province:'',
				city:'',
				district:'',
				detailaddr:'',
				postcode:'',
				remark: '',
				domain:[],
				//domain: [{ name: window.location.host }],
				webtitle: '',
				addressall:''
			},
			groupkey: '',
			btndisabled: true,
			showgroupwin: false,
			ip: '',
			countrylist:[],
			loading:false,
			cwlist:[],
			r_namelist:[]
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/group.scss');
		});
	},
	methods: {
		//获取角色下拉选项
		GetRoleOption() {
			var that = this;
			this.$apipost.get.GetRoleOption().then(res => {
				that.r_namelist = res.list;
			});
		},
		//获取计费方案下拉选项
		GetPayruleOption() {
			var that = this;
			this.$apipost.get.GetPayruleOption().then(res => {
				that.cwlist = res.list;
			});
		},
		//获取ip
		GetIp() {
			var that = this;
			this.$apipost.get.GetSystemParam({ type: 1, showname: 'ip地址' }).then(res => {
				that.ip = res.state;
			});
		},
		//初始化
		init(param) {
			this.groupkey = '';
			this.showgroupwin = true;
			if (param != undefined) {
				if (param.groupkey != undefined) {
					this.groupkey = param.groupkey;
					this.GetShopInfo();
					this.btndisabled = false;
				}
			} else {
				this.groupinfo = {
					s_name: '',
					isshop: 'true',
					r_name: '',
					c_id: '',
					country: '',
					province:'',
					city:'',
					district:'',
					detailaddr:'',
					postcode:'',
					remark: '',
					addressall:'',
					domain: [{ name: window.location.host }],
					webtitle: ''
				};
			}
			if(this.groupkey==''){
				this.GetRoleOption();
				this.GetPayruleOption();
			}
			//this.GetIp();
		},
		//获取门店详细信息
		GetShopInfo() {
			var that = this;
			if (this.groupkey != '') {
				this.$apipost.get.GetGroup({ search: { id: this.groupkey }, userid: '' }).then(res => {
					if (res.list != undefined) {
						
						if (res.list.length == 1) {
							that.groupinfo = res.list[0];
							that.GetRoleOption();
							that.GetPayruleOption();
						}
					}
				});
			}
		},
		changeinput() {
			if (this.groupinfo.s_name != '') {
				this.btndisabled = false;
			}
		},
		addrinput(value){
			var that=this;
			this.$apipost.get.GetCountry({
				searchkey: value
			}).then(res => {
				if (res != '') {
					that.countrylist = res.list;
				}
			});
		},
		//保存分组信息
		savegroup() {
			var that = this;
			if (this.groupinfo.s_name == '') {
				this.$tool.message('请输入门店名称', 0);
				return false;
			}
			//if (this.checkdomain()) {
				this.groupinfo.u_userid = localStorage.getItem('userid');
				this.$tool.loading('正在保存', 'group');
				this.$apipost.post.SaveGroup({ groupinfo: this.groupinfo }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '1') {
						this.$tool.message('保存成功', 1);
						setTimeout(function() {
							that.showgroupwin = false;
							that.$parent.refreshgrid(true);
						}, 1000);
					} else {
						this.$tool.message(res.message, 0);
					}
				});
			//}
		},
		//增加域名
		adddomain() {
			this.groupinfo.domain.push({ name: '' });
		},
		//移除域名
		removedomain(index) {
			this.groupinfo.domain.splice(index, 1);
		},
		checkdomain() {
			var that = this;
			var domainlist = this.groupinfo.domain;
			var istrue = true;
			for (var i = 0; i < domainlist.length; i++) {
				if (domainlist[i].name != '') {
					if (!this.$tool.isdomain(domainlist[i].name)) {
						this.$tool.message(domainlist[i].name + ' 域名不合法', 0);
						istrue = false;
						break;
					}
				}
			}
			return istrue;
		}
	}
};
</script>
